// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__YxNpo","quickBox":"styles_quickBox__6ICxo","box":"styles_box__0jaOV","text":"styles_text__IZyq0","title":"styles_title___VlXZ"};
module.exports.__checksum = "cf72008d1f0e"
